import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../../lib/images';

export const Locations = () => {
  const locations = [
    { name: 'Jaipur', img: IMAGES.locations.jaipur },
    { name: 'Udaipur', img: IMAGES.locations.udaipur },
    { name: 'Ranthambore', img: IMAGES.locations.ranthambore },
    { name: 'Desert Dunes', img: IMAGES.locations.desert }
  ];

  return (
    <section id="locations" className="py-32 bg-background relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row justify-between items-end mb-20 gap-8">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-secondary mb-6 font-medium">Chapter 03 — Destinations</div>
            <h2 className="text-5xl md:text-7xl font-editorial">Where we <span className="italic text-secondary">create magic</span>.</h2>
          </div>
          <p className="max-w-xs text-foreground/70 font-light">From the royal forts of Rajasthan to the pristine lakes of Udaipur, we operate at India&apos;s most prestigious venues.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {locations.map((loc, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1, duration: 0.8 }}
              className="group relative h-[500px] overflow-hidden cursor-pointer"
            >
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-500 z-10" />
              <img 
                src={loc.img} 
                alt={loc.name} 
                className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-1000"
              />
              <div className="absolute bottom-8 left-8 z-20 overflow-hidden">
                <motion.h3 
                  className="text-white text-3xl font-editorial"
                >
                  {loc.name}
                </motion.h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
